// extracted by mini-css-extract-plugin
export default {"head":"View_head__PCwhd","details":"View_details__iSoKa","button":"View_button__U83UA","preview":"View_preview__08TS2"};